import { render, staticRenderFns } from "./odontograma.vue?vue&type=template&id=a8ab8fd6&scoped=true"
import script from "./odontograma.vue?vue&type=script&lang=js"
export * from "./odontograma.vue?vue&type=script&lang=js"
import style0 from "./odontograma.vue?vue&type=style&index=0&id=a8ab8fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ab8fd6",
  null
  
)

export default component.exports